import { render, staticRenderFns } from "./ssoCallback.vue?vue&type=template&id=5e2c4daa&"
import script from "./ssoCallback.vue?vue&type=script&lang=js&"
export * from "./ssoCallback.vue?vue&type=script&lang=js&"
import style0 from "./ssoCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports